import {
  defineProductBrand,
  registerProductBrand
} from "./chunk-KAZLV66X.js";

// src/product-registry.ts
var REGISTRY = [];
var SLUG_SHAPE = /^[a-z0-9]+(-[a-z0-9]+)*$/;
function assertSlugIsAvailable(slug, id) {
  if (!SLUG_SHAPE.test(slug)) {
    throw new Error(
      `[product-registry] Invalid slug "${slug}" for product "${id}" \u2014 slugs MUST be lowercase kebab-case (a-z, 0-9, hyphen-separated).`
    );
  }
  const SHELL_GLOBAL = /* @__PURE__ */ new Set([
    "settings",
    "help",
    "library",
    "login",
    "logout",
    "oauth",
    "dashboard",
    "columns",
    "tokens",
    "tokens-themes"
  ]);
  if (SHELL_GLOBAL.has(slug)) {
    throw new Error(
      `[product-registry] Slug "${slug}" is reserved by the DS shell. Pick a different slug for product "${id}".`
    );
  }
}
function defineProduct(input) {
  const brandPrefix = (input.brandPrefix ?? "Exxat").trim();
  const brandSuffix = input.brandSuffix.trim();
  const slug = input.slug.trim();
  return {
    ...input,
    brandPrefix,
    brandSuffix,
    slug,
    defaultPath: input.defaultPath ?? `/${slug}/dashboard`
  };
}
function registerProducts(products) {
  for (const product of products) {
    assertSlugIsAvailable(product.slug, product.id);
    const existingIndex = REGISTRY.findIndex((p) => p.id === product.id);
    if (existingIndex >= 0) {
      REGISTRY[existingIndex] = product;
    } else {
      REGISTRY.push(product);
    }
    registerProductBrand(defineProductBrand({
      id: product.id,
      prefix: product.brandPrefix,
      suffix: product.brandSuffix,
      brandColor: product.brandColor,
      ...product.brand
    }));
  }
}
function unregisterProducts(ids) {
  if (ids.length === 0) return;
  const remove = new Set(ids);
  for (let i = REGISTRY.length - 1; i >= 0; i--) {
    if (remove.has(REGISTRY[i].id)) {
      REGISTRY.splice(i, 1);
    }
  }
}
function listRegisteredProducts() {
  return REGISTRY;
}
function getRegisteredProduct(id) {
  return REGISTRY.find((p) => p.id === id);
}
function getRegisteredProductBySlug(slug) {
  return REGISTRY.find((p) => p.slug === slug);
}
function asBuiltInProduct(id) {
  if (id === "exxat-prism" || id === "exxat-design-os" || id === "exxat-admin" || id === "exxat-people" || id === "exxat-courses" || id === "exxat-personnel" || id === "exxat-one-sites" || id === "exxat-curriculum-mapping" || id === "exxat-compliance" || id === "exxat-surveys" || id === "exxat-exam-management" || id === "exxat-accreditation" || id === "exxat-student-success" || id === "exxat-custom") {
    return id;
  }
  return void 0;
}
function __resetProductRegistry() {
  REGISTRY.length = 0;
}

export {
  defineProduct,
  registerProducts,
  unregisterProducts,
  listRegisteredProducts,
  getRegisteredProduct,
  getRegisteredProductBySlug,
  asBuiltInProduct,
  __resetProductRegistry
};
